import { useSetPageTitle } from "src/hooks/useSetPageTitle";
import { AppLayout } from "src/components/layout/app-layout";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import TrendsTab from "./tabs/trends.tab";
import SurveyResultsPage from "../survey-results/survey-results.page";
import OverviewTab from "./tabs/overview.tab";

const ResultsPage = () => {
  useSetPageTitle('Reports');
  const navigate = useNavigate();
  const { clientId, extSurveyId } = useParams<{ clientId?: string; extSurveyId?: string; shareId?: string }>();
  const [searchParams] = useSearchParams();

  const reportsTabs = [
    { id: 'overview' as const, key: 'ALL', label: 'Overview' },
    { id: 'preview' as const, key: 'NEVER', label: 'Overview (Beta)' },
    { id: 'trends' as const, key: 'trends', label: 'Trends' },
  ];

  const { tab } = useParams<{ tab?: string }>();

  const validTabs = reportsTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    const search = searchParams.toString() ? `?${searchParams.toString()}` : '';
    if (clientId) {
      navigate(`/client/${clientId}/results/${tabId}/${extSurveyId}${search}`);
    } else {
      navigate(`/results/${tabId}/${extSurveyId}${search}`);
    }
  };

  // New layout for org admins and regular users
  return (
    <AppLayout
      activePage="/results"
      navbarProps={{
        showBackButton: false,
        backPath: clientId ? `/client/${clientId}/reports` : '/surveys',
        tabs: reportsTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)]">
        {currentTab === '' || currentTab === 'overview' && <SurveyResultsPage />}
        {currentTab === 'preview' && <OverviewTab />}
        {currentTab === 'trends' && <TrendsTab />}
        {/* {currentTab === 'analysis' && <AnalysisTab />} */}
      </div>
    </AppLayout>
  );
};

export default ResultsPage;